// Provided solution from svggator on stopping single play through svgs from repeating
window.addEventListener('load', () => {
    const animatedIds = ['eafeETYouZp1', 'eDC0hSAMPsO1', 'eqMWVIAnNQX1', 'eNTpUjHtO3V1', 'emLyzZuXbB61', 'ekdDi1WshXC1', 'emefFgrT0x11'];

    for ( let animatedId of animatedIds ) {
        document.getElementById(animatedId)?.svgatorPlayer?.ready(
            player => player.on('end', () =>
                player.on('play,restart', () => player.pause().seek(100)))
        );
    }
});